import _defineProperty from "babel-runtime/helpers/defineProperty";

var _types$$types$UPDATE_;

import types from "./mutation-types";
import storage from "@/tools/storage.js";
import defineConfig from "@/config/defineConfig.js";

export default (_types$$types$UPDATE_ = {}, _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_FIELD_CHANGE, function (state, payload) {
  state.fieldchange = payload;
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_BIZ_ROUTE_INDEX, function (state, payload) {
  state.bizRouteIndex = payload;
  storage.$storage.setSession(defineConfig.$definecfg.BIZ_ROUTE_INDEX, payload);
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_PRE_BIZ_ROUTE_INDEX, function (state, payload) {
  state.preBizRouteIndex = payload;
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_BIZ_ROUTE_TABLE, function (state, payload) {
  state.bizRouteTable = payload;
  storage.$storage.setSession(defineConfig.$definecfg.BIZ_ROUTE_TABLE, payload);
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_BUSI_CODE, function (state, payload) {
  state.busicode = payload;
  storage.$storage.setSession(defineConfig.$definecfg.BUSI_CODE, payload);
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_USER_TYPE, function (state, payload) {
  state.usertype = payload;
  storage.$storage.setSession(defineConfig.$definecfg.USER_TYPE, payload);
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_NAV_ROUTE_TABLE, function (state, payload) {
  state.navRouteTable = payload;
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_SUBNAV_INDEX, function (state, payload) {
  state.subnavIndex = payload;
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_COMPONENT_BUTTON_CLICK, function (state, payload) {
  state.componentbuttonclick = payload;
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_MODULE_BUTTON_CLICK, function (state, payload) {
  state.modulebuttonclick = payload;
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_MODULE_CUSTOMIZE_BUTTON_CLICK, function (state, payload) {
  state.moduleCustomizeButtonClick = payload;
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_MODULE_ZDCUSTOMIZE_BUTTON_CLICK, function (state, payload) {
  state.moduleZDCustomizeButtonClick = payload;
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_MODULE_BENIFICUSTOMIZE_BUTTON_CLICK, function (state, payload) {
  state.moduleBenifiCustomizeButtonClick = payload;
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_MODULE_DOWNLOAD_BUTTON_CLICK, function (state, payload) {
  state.moduleDownloadButtonClick = payload;
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_MODULE_IMPORT_BUTTON_CLICK, function (state, payload) {
  state.moduleImportButtonClick = payload;
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_QUEUE_WAIT_NUM, function (state, payload) {
  state.queuewaitnum = payload;
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_IS_RECORD, function (state, payload) {
  state.isrecord = payload;
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_IS_LOGIN, function (state, payload) {
  state.isLogin = payload;
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_HAS_PASSWORD, function (state, payload) {
  state.hasPassword = payload;
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_OLD_BIZ_DATA, function (state, payload) {
  state.oldBizData = payload;
  storage.$storage.setSession(defineConfig.$definecfg.OLD_BIZ_DATA, payload);
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_LEFT_CLICK_STATE, function (state, payload) {
  state.leftClickState = payload;
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_REJECT_REMARK, function (state, payload) {
  state.rejectRemark = payload;
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_OPEN_CURRENT_NUM, function (state, payload) {
  state.openCurrentNum = payload;
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_IS_EXTERAL, function (state, payload) {
  state.isExteral = payload;
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_IMAGE_COLLECT_OBJ, function (state, payload) {
  state.imageCollectObj = payload;
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_IS_JUMPTO_IAMGE, function (state, payload) {
  state.isJumpToImageCollect = payload;
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_ROUTE_TABLE_FLAG, function (state, payload) {
  state.updateRouteTableFlag = payload;
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_IMG_NAV_ROUTE_TABLE, function (state, payload) {
  state.updateImgNavRouteFlag = payload;
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_REJECT_TOGGLED, function (state, payload) {
  state.rejectToggled = payload;
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATA_IMAGE_NAV_SUBMIT_NEED, function (state, payload) {
  state.imageNavSubmitNeed = payload;
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATA_IMAGE_NAV_SUBMIT_SUCCESS, function (state, payload) {
  state.imageNavSubmitSuccess = payload;
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_TRANS_BIZ_DATA, function (state, payload) {
  state.transBizData = payload;
  storage.$storage.setSession(defineConfig.$definecfg.transBizData, payload);
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_LOADING, function (state, payload) {
  if (typeof payload === "string") {
    state.isLoading = true;
    state.loadingText = payload;
    window.vm && vm.myLoading(payload);
  } else if (typeof payload === "boolean") {
    if (payload) {
      state.isLoading = true;
      state.loadingText = "加载中";
      window.vm && vm.myLoading("加载中");
    } else {
      state.isLoading = false;
      window.vm && vm.myLoading({ showLoading: false });
    }
  }
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_TOKEN, function (state, payload) {
  state.token = payload;
  storage.$storage.setSession(defineConfig.$definecfg.TOKEN, payload);
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_USER_INFO, function (state, payload) {
  state.userInfo = payload;
  storage.$storage.setSession(defineConfig.$definecfg.USER_INFO, payload);
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_APPT_SN, function (state, payload) {
  state.apptSn = payload;
  storage.$storage.setSession(defineConfig.$definecfg.APPT_SN, payload);
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_B_SNO, function (state, payload) {
  state.bSno = payload;
  storage.$storage.setSession(defineConfig.$definecfg.B_SNO, payload);
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_OPEN_ACCTTYPE, function (state, payload) {
  state.openAcctType = payload;
  storage.$storage.setSession(defineConfig.$definecfg.OPEN_ACCTTYPE, payload);
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_APPT_STATUS, function (state, payload) {
  state.apptStatus = payload + "";
  storage.$storage.setSession(defineConfig.$definecfg.APPT_STATUS, payload);
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_CUSTOMER_INFO, function (state, payload) {
  state.customerInfo = payload;
  storage.$storage.setSession(defineConfig.$definecfg.CUSTOMER_INFO, payload);
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_CAN_CLEAN_DATA, function (state, payload) {
  state.canCleanData = payload;
  storage.$storage.setSession(defineConfig.$definecfg.CAN_CLEAN_DATA, payload);
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_MOBILE_LOGIN, function (state, payload) {
  state.mobileLogin = payload;
  storage.$storage.setSession(defineConfig.$definecfg.UPDATE_MOBILE_LOGIN, payload);
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_LAST_MOBILE_LOGIN, function (state, payload) {
  state.lastMobileLogin = payload;
  storage.$storage.setSession(defineConfig.$definecfg.UPDATE_LAST_MOBILE_LOGIN, payload);
}), _defineProperty(_types$$types$UPDATE_, types.$types.UPDATE_PAGE_RELOAD, function (state, payload) {
  state.pageReload = payload;
  storage.$storage.setSession(defineConfig.$definecfg.UPDATE_PAGE_RELOAD, payload);
}), _types$$types$UPDATE_);


//////////////////
// WEBPACK FOOTER
// ./src/vuex/mutations.js
// module id = 903
// module chunks = 2